import React, { FC } from 'react';
import { ColumnHeader } from 'components/organisms/projects-report/common';
import { useTranslation } from 'hooks/use-translation';
import { WidgetTable } from '../../common';
import { UsersReportRecord } from '../../types';
import { NameCell } from './name-cell';

export const TaskOnTimeCompletionTable: FC<{ records: UsersReportRecord[] }> =
  ({ records }) => {
    return (
      <WidgetTable>
        <WidgetTable.HeaderRow>
          <WidgetTable.HeaderRow.Cell>
            <ColumnHeader title={useTranslation('team_members')} />
          </WidgetTable.HeaderRow.Cell>
          <WidgetTable.HeaderRow.Cell>
            <ColumnHeader
              title={useTranslation(
                'reports.columns.tasks.completed_on_time_percentage',
              )}
            />
          </WidgetTable.HeaderRow.Cell>
        </WidgetTable.HeaderRow>

        {records.map(
          ({
            firstName,
            lastName,
            photoUrl,
            taskInfo: { completedOnTimeCountPercentage },
          }) => (
            <WidgetTable.BodyRow>
              <WidgetTable.BodyRow.Cell>
                <NameCell
                  firstName={firstName}
                  lastName={lastName}
                  photoUrl={photoUrl}
                />
              </WidgetTable.BodyRow.Cell>
              <WidgetTable.BodyRow.Cell>
                {completedOnTimeCountPercentage?.toFixed(1)}%
              </WidgetTable.BodyRow.Cell>
            </WidgetTable.BodyRow>
          ),
        )}
      </WidgetTable>
    );
  };
